import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from './constants';

const adService = createApi({
    reducerPath: 'adService',
    baseQuery: fetchBaseQuery({
        baseUrl: BASE_URL,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem('admin')
                ? JSON.parse(localStorage.getItem('admin')).token
                : null;
            if (token) headers.set('Authorization', `Bearer ${token}`);
            return headers;
        },
    }),
    endpoints: (builder) => ({

        fetchAds: builder.query({
            query: ({ page = 1, search = "" }) =>
                `admin/ads?page=${page}&search=${search}`,
        }),

        fetchAdDetails: builder.query({
            query: (id) => `admin/ad-details/${id}`,
        }),



    }),
});

export const { useFetchAdsQuery, useFetchAdDetailsQuery } = adService;
export default adService;
